/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import Icon from "uis/Icon";
import { useEffect, useState } from "react";
import Button from "uis/Button";
import { gaEvent } from "utils/ga-utils";

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
`;
const ImageContainer = styled.div`
    height: 60%;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${theme.neutral50};
`;

const Content = styled.div`
    height: 25%;
    display: flex;
    flex-direction: column;
    gap: 35px;
    align-items: center;
    justify-content: center;
`;

const Title = styled.div`
    font-size: 24px;
    font-weight: 500;
    color: ${theme.neutral900};
`;
const SubText = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${theme.neutral600};
`;

const Footer = styled.div`
    height: 15%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    padding: 0px 50px;
    width: 100%;
`;
const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
`;
const SkipButton = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${theme.neutral400};
    text-decoration: underline;

    cursor: pointer;
`;

type Props = {
    onClickNext: () => void;
    onClickSkip: () => void;
}

export default function WelcomePage(props: Props) {
    const { onClickNext, onClickSkip } = props;

    useEffect(() => {
        gaEvent("첫 온보딩 - 환영");
    }, []);

    return (
        <RootContainer>
            <ImageContainer>
                <Icon name="meeting-illust" color={theme.primary500} width={350} />
            </ImageContainer>
            <Content>
                <Title>환영합니다! Mile Visitors의 방문 관리 과정을 알려드릴게요.</Title>
                <SubText>방문 등록부터 기업 방문 안내, 메신저를 활용한 방문 알림까지 마일의 프로세스를 알아보세요.</SubText>
            </Content>
            <Footer>
                <SkipButton onClick={onClickSkip}>건너뛰기
                </SkipButton>
                <ButtonContainer>
                    <Button
                        title="알아보기"
                        type="primary"
                        styles={{
                            container: css`
                                width: 260px;
                                height: 60px;
                            `,
                            text: css`
                                font-size: 18px;
                            `,
                        }}
                        onClick={onClickNext}
                    />
                </ButtonContainer>
            </Footer>
        </RootContainer>
    );
}
